import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum OwnerRevenueFormulaType {
  RESERVATION_BASE_PRICE = 'RESERVATION_PRICE_BASE',
  MANAGER_COMMISSION = 'MANAGER_COMMISSION',
  FIX_FEE_PER_RESERVATION = 'FIX_FEE_PER_RESERVATION',
}

export class OwnerRevenueFormula extends Codebook<OwnerRevenueFormulaType> {
  private constructor(
    public readonly id: OwnerRevenueFormulaType,
    public readonly name: () => string,
  ) {
    super(id)
  }

  static readonly RESERVATION_BASE_PRICE = new OwnerRevenueFormula(
    OwnerRevenueFormulaType.RESERVATION_BASE_PRICE,
    () => $t('Reservation price'),
  )
  static readonly MANAGER_COMMISSION = new OwnerRevenueFormula(
    OwnerRevenueFormulaType.MANAGER_COMMISSION,
    () => $t('Manager commission'),
  )
  static readonly FIX_FEE_PER_RESERVATION = new OwnerRevenueFormula(
    OwnerRevenueFormulaType.FIX_FEE_PER_RESERVATION,
    () => $t('Fix fee per reservation'),
  )
}
